import axios from 'axios'
import * as vars from './vars';

// get all connections for a userId
export function getAllConnections(state, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/GetAllConnections',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            state: state
        }
    })
}

// get a connection between two users
export function getConnection(otherUsername, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/connections/FetchPossibleUserConnection',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            otherUsername: otherUsername
        }
    })
}

// respond to a connection request
export function respondToConnection(connectionId, state, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/connections/UpdateConnection',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            connectionId: connectionId,
            state: state
        }
    })
}

// propose an existing user connection
export function proposeExistingUserConnection(respondentUserId, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/connections/ProposeConnection',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            'respondentUserId': respondentUserId
        }
    })
}

// delete a connection
export function deleteExistingConnection(connectionId, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/connections/RemoveConnection',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            connectionId: connectionId
        }
    })
}